@if(borrower()) {
  <app-borrower-status-picker
    [options]="options()"
    [status]="borrower().status"
    [disabled]="disabled()"
    [disabledReason]="disabledReason()"
    [tooltip]="
      borrower().stage === 'inactive'
        ? 'Reason: ' + borrower().last_inactive_status?.reason
        : ''
    "
    (statusChange)="handleChangeStatus($event)"
  ></app-borrower-status-picker>
} @else {
  <ng-content></ng-content>
}
